import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
import {Observable, of} from 'rxjs';
import {delay, map, startWith} from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

export class FetchTransferCase {
  id: Int16Array;
  refno: string;
  ShortName: string;
  Type: string;
  IsSent: any;
  NoticeDt: string;
  ReceiptDt: string;
  TargetDt: string;
  DueDt: string;
  CategoryID: Int16Array;
  SubCategoryID: Int16Array;
  ExposureAmt: string;
  NegotiationAmt: string;
  ReceivedAmt: string;
  BalanceAmt: string;
  CompanyID: Int16Array;
  DeptID: Int16Array;
  StateID: Int16Array;
  CityID: Int16Array;
  CourtID: Int16Array;
  CurrencyID: Int16Array;
  LawyerID: Int16Array;
  CourtNo: string;
  LastDateToRespond: string;
  AgencyID: Int16Array;
  ManagerID: Int16Array;
  LeaderID: Int16Array;
  Stages: Int16Array;
  Seriousness: string;
  recEnable: Int16Array;
  recUser: Int16Array;
  recAddUser: Int16Array;
  Section: string;
  FIRDate: string;
  FIRNo: string;
  PoliceStation: string;
  InvestigatingOfficer: string;
  ManagerPreID: any;
  LeaderPreID: any;
  BenchNo: string;
  JudgeName: string;
  LawyerName: string;
  stateName: string;
  cityName: string;
  jurisdictionName: string;
  agencyName: string;
  managerName: string;
  LeaderName: string;
  currencyName: string;
  categoryName: string;
  subcategoryName: string;
  departmentName: string;
  companyName: string;
  statusName: string;
  seriousnessName: string;
  SectionName: string;
  }
  export class UpdateTransferCase {
    id: Int16Array;
    refno: string;
    ShortName: string;
    Type: string;
    IsSent: any;
    NoticeDt: string;
    ReceiptDt: string;
    TargetDt: string;
    DueDt: string;
    CategoryID: Int16Array;
    SubCategoryID: Int16Array;
    ExposureAmt: string;
    NegotiationAmt: string;
    ReceivedAmt: string;
    BalanceAmt: string;
    CompanyID: Int16Array;
    DeptID: Int16Array;
    StateID: Int16Array;
    CityID: Int16Array;
    CourtID: Int16Array;
    CurrencyID: Int16Array;
    LawyerID: Int16Array;
    CourtNo: string;
    PreBenchNo: string;
    PreJudgeName: string;
    PreLawyerID: any;
    LastDateToRespond: string;
    AgencyID: Int16Array;
    ManagerID: Int16Array;
    LeaderID: Int16Array;
    Stages: Int16Array;
    Seriousness: string;
    recEnable: Int16Array;
    recUser: Int16Array;
    recAddUser: Int16Array;
    Section: string;
    FIRDate: string;
    FIRNo: string;
    PoliceStation: string;
    InvestigatingOfficer: string;
    ManagerPreID: any;
    LeaderPreID: any;
    BenchNo: string;
    JudgeName: string;
    LawyerName: string;
    }

  export interface Section {
    hdID: string;
    MainDescr: string;
  }
  export interface NoticeCaseStatus {
    NoticeStatus: string;
    ConvertinCase: string;
    refno: string;
  }
  @Injectable({ providedIn: 'root'})

@Component({
    selector: 'app-case-transfer',
    templateUrl: './case-transfer.component.html',
    styleUrls: ['./case-transfer.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})


export class CaseTransferComponent implements OnInit {
  FetchCaseType: string;
  FetchSection: string;
  FetchRefNo: string;
  FetchAgency: string;
  FetchShortName: string;
  FetchManager: string;
  FetchCategory: string;
  FetchSubCategory: string;
  FetchLeader: string;
  FetchCaseDate: string;
  FetchCompany: string;
  FetchDepartment: string;
  FetchReceivingDate: string;
  FetchState: string;
  FetchTargetDate: string;
  FetchCity: string;
  FetchBenchNo: string;
  FetchJurisdiction: string;
  FetchJudgeName: string;
  FetchCourtNameNo: string;
  FetchLawyerName: string;
  FetchStatus: string;
  FetchDueDate: string;
  FetchSeriousness: string;
  FetchLastDateRespond: string;
  FetchCurrency: string;
  FetchFIRDate: string;
  FetchExposureAmount: string;
  FetchFirNo: string;
  FetchRecoveryAmount: string;
  FetchPoliceStation: string;
  FetchNegotiationAmount: string;
  FetchInvestigationOfficer: string;
  FetchBalanceAmount: string;
  TypeHeader: string;
  Type: string;
  Sent: string;
  Received: string;
  id: any;
  Category: any;
  SubCategory: any;
  Company: any;
  Department: any;
  Designation: any;
  Agency: any;
  Manager: any;
  Leader: any;
  User: any;
  State: any;
  City: any;
  Jurisdiction: any;
  Stages: any;
  Seriousness: any;
  url: string;
  pageurl: string;
  RefNo: string;
  addFormTranferCase: FormGroup;
  getdata: string;
  numb: any;
  DateofNotice: string;
  DueDate: string;
  LastDate: string;
  DateofReceiving: string;
  Currency: any;
  Lawyer: any;
  TargetDate: string;
  str: string;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  NoticeCaseData: any;
  DisplayExistNotice: string;
  SectionList: Section[] = [];
  selectedSections = [];
  DisplaySaveNoticeButton: string;
  HeaderButtonCaption: string;
  editable: boolean;
  clicked: boolean;
  DownloadURL: string;
  NoticeCaseStatus: string;
  HideButtonSubmit: string;
  HideContent: string;
  RightsID: string;
  RouteGMSection: string;
  RouteGMAgency: string;
  RouteGMCategory: string;
  RouteGMSubCategory: string;
  RouteGMDepartment: string;
  RouteGMState: string;
  RouteGMNoticeStatus: string;
  RouteGMCaseStatus: string;
  RouteGMCity: string;
  RouteGMJurisdiction: string;
  RouteGMCurrency: string;
  RouteUserMaster: string;
  RouteCompany: string;
  ManagerPreID: any;
  LeaderPreID: any;
  varInterval: any;
  PageStatus: string;
  ConvertinCaseNo: any;
  PreBenchNo: string;
  PreJudgeName: string;
  PreLawyerID: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService ) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    this.ManagerPreID = 0 ;
    this.LeaderPreID = 0 ;
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[3];
    this.CheckRights();
    if (pagehead[2] == "notice" || pagehead[2] == "Notice") {
      this.TypeHeader = 'Notice';
      this.Type = 'Notice';
      this.Sent = 'Sent';
      this.Received = 'Received';
      if (this.RightsID.includes('202030001') || this.RightsID.includes('202030021') || this.RightsID.includes('202030000')) {
      } else {
        window.location.href = "module/0";
      }
    } else if (pagehead[2] == 'case' ||  pagehead[2] == "Case" ) {
      this.TypeHeader = 'Case';
      this.Type = 'Case';
      this.Sent = 'Filled by Us';
      this.Received = 'Against Us';
      if (this.RightsID.includes('202032001') || this.RightsID.includes('202032021') || this.RightsID.includes('202032000')) {
      } else {
        window.location.href = "module/0";
      }
    }
    this.DisplayExistNotice = "!isHidden";
    this.HideButtonSubmit = "";
    this.HideContent = "";
    this.DisplaySaveNoticeButton = "submit";
    this.HeaderButtonCaption = "Create";
    this.fetchRouteDataRights();
    //this.getLawyerName();
    this.getMasterData();
    if (this.id > 0) {
      this.HeaderButtonCaption = "Update";
      this.DisplayExistNotice = "";
      this.DisplaySaveNoticeButton = "submit";
      this.fetchNoticeCaseData();
    }
    // Set Validation of Add Notice /  Case Form on Header Part
    this.addFormTranferCase = this.formBuilder.group({
      Notice: [''], Agency: [''], ShortName: [''], Manager: [''], Category: [''], SubCategory: [''], Company: [''], Currency: [''], Lawyer: [''],
      Department: [''], ExposureAmmount: [''], DateofNotice: ['', Validators.required], RefNo: ['', Validators.required],
      State: [''], Leader: [''], DateofReceiving: [''], TargetDate: [''],  City: [''], Stages: [''], Jurisdiction: [''],
      Seriousness: [''], DueDate: [''], LastDate: [''], CourtName: [''], RecoveryAmount: [''],  NegotiationAmount: [''],
      BalanceAmount: [''], Section: [''], FIRDate: [''], FIRNo: [''], PoliceStation: [''], InvestigatingOfficer: [''] , BenchNo: [''],
      JudgeName: [''], LawyerName: [''] });

    // Set By Default Value on Header Part
    this.addFormTranferCase.patchValue({
        Notice: '1' , State: '0', Agency: '0', Manager: '0', Category: '0' , SubCategory: '0', Company: '0', Department: '0',
        Leader: '0', City: '0', Stages: '0', Jurisdiction: '0', Seriousness: '0', Currency: '0', Lawyer: '0' });

  }
  get f() { return this.addFormTranferCase.controls; }
  CheckRights() {

    this.http.get(this.url + 'Notice/Fetch_Notice_Case_Status?id=' + this.id)
    .subscribe( (data) =>   {
        if (data == null) {
        } else {
          const noticeCaseStatus: NoticeCaseStatus = JSON.parse(data.toString())[0];
          this.NoticeCaseStatus = noticeCaseStatus.NoticeStatus;
          this.ConvertinCaseNo = noticeCaseStatus.ConvertinCase;
          if (this.NoticeCaseStatus == "1") {
            this.HeaderButtonCaption = "Re-Work";
            this.HideContent = "!isHidden";
          }
          if (this.ConvertinCaseNo != null) {
            this.PageStatus = "Note: This Notice Converted in Case Ref No (" + noticeCaseStatus.refno + " )";
            this.HideButtonSubmit = "!isHidden";
            this.HideContent = "!isHidden";
          } else { this.PageStatus = ""; }
        }
       }
    );
  }
  fetchRouteDataRights() {
    // tslint:disable-next-line: max-line-length
    this.RouteCompany = this.RightsID.includes('202044000') || this.RightsID.includes('202044001') || this.RightsID.includes('202044021') ? '/navcompany/company/0' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? '/user-master' : '/module/0';
    if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
     this.RouteGMSection = "/general-master/070";
     this.RouteGMAgency = "/general-master/040";
     this.RouteGMCategory = "/general-master/045";
     this.RouteGMSubCategory = "/general-master/050";
     this.RouteGMDepartment = "/general-master/030";
     this.RouteGMState = "/general-master/010";
     this.RouteGMNoticeStatus = "/general-master/110";
     this.RouteGMCaseStatus = "/general-master/105";
     this.RouteGMCity = "/general-master/015";
     this.RouteGMJurisdiction = "/general-master/020";
     this.RouteGMCurrency = "/general-master/115";
    } else {
    this.RouteGMSection = "/module/0";
    this.RouteGMAgency = "/module/0";
    this.RouteGMCategory  ="/module/0";
    this.RouteGMSubCategory = "/module/0";
    this.RouteGMDepartment = "/module/0";
    this.RouteGMState = "/module/0";
    this.RouteGMNoticeStatus = "/module/0";
    this.RouteGMCaseStatus = "/module/0";
    this.RouteGMCity = "/module/0";
    this.RouteGMJurisdiction = "/module/0";
    this.RouteGMCurrency = "/module/0";
   }
 }
 onStateSelect(GenID) {
  this.getMaster('015', GenID).subscribe( (data: any) => {
    this.City = data ;
    let data1: any;
    this.Jurisdiction = data1;
    this.addFormTranferCase.patchValue({City: '0', Jurisdiction: '0'}); } );
}
onCitySelect(GenID) {
  this.getMaster('020', GenID).subscribe( (data: any) => {
    this.Jurisdiction = data;
    this.addFormTranferCase.patchValue({Jurisdiction: '0'}); } );
}
onCategorySelect(GenID) {
this.getMaster('050', GenID) .subscribe( (data: any) => {
    this.SubCategory = data;
    this.addFormTranferCase.patchValue({ SubCategory: '0' });
  });
}
 getMasterData() {
  // Section= 070
   this.getMaster('070', '') .subscribe( (data: any) => {
     this.SectionList = data;});
   this.getMaster('115', '') .subscribe( (data: any) => {
     this.Currency = data;
    });

   // 40 = Agency Record
   this.getMaster('040', '') .subscribe( (data: any) => {
   this.Agency = data; });
   // 10 = State Record
   this.getMaster('010', '') .subscribe( (data: any) => {
   this.State = data; });
   // 45= Category Record
   this.getMaster('045', '') .subscribe( (data: any) => {
   this.Category = data; });
   // 30= Department
   this.getMaster('030', '') .subscribe( (data: any) => {
   this.Department = data; });
   // 35= Designation

   /************For Get Stages*************  */
   if (this.TypeHeader == 'Notice') {
     this.getMaster('105', '') .subscribe( (data: any) => {
       this.Stages = data; });
   } else {
     this.getMaster('110', '') .subscribe( (data: any) => {
       this.Stages = data; });
   }

 /********** For Get Compant Master Name List ****** */
   this.http.get(this.url + 'Notice/GetCompanyMasterList') .subscribe( (data) => {
   this.Company = JSON.parse(data.toString()); });
 /********** For Get Contact Manager Name ****** */
   this.http.get(this.url + 'GM/GetEmployee') .subscribe( (data) => {
   this.Manager = JSON.parse(data.toString()); });
 /************For Get Seriousness************* */
   this.getSysData('010') .subscribe( (data: any) => {
   this.Seriousness = data; });
 /************For Get LawyerName************* */
   this.http.get(this.url + 'Help/FetchHelpLawyerName') .subscribe( (data) => {
   this.Lawyer = JSON.parse(data.toString()); });
}
getSysData(GID: string) {
 return this.http.get(this.url + 'SysData/GetSysData?GenID=' + GID )
 .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
 }
// For Bind Field on Page Load Like Company, Department, State, Agency, City
getMaster(GID: string, MID: string) {
 return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
 .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
 }

 onHeaderSubmit(HearderFormData) {

  if (HearderFormData.RefNo == "") { this.clicked = false; this.alertService.warn("Please Enter Refno",this.options); this.clicked = false; return; }

  if (this.addFormTranferCase.invalid) { this.clicked = false;  return; }

  if (HearderFormData.Notice == "") {
          this.clicked = false;
          if (this.Type == "Notice") { this.alertService.warn("Please Select Notice Type Received or Sent",this.options);
         } else { this.alertService.warn("Please Select Case Type Filled By Us or Against Us",this.options);  } return;
        } else {
         this.numb = 1;
         let noticeobj: UpdateTransferCase = {
          id: this.id,
          refno: HearderFormData.RefNo,
          ShortName: HearderFormData.ShortName,
          Type: this.Type,
          IsSent: HearderFormData.Notice,
          CurrencyID: HearderFormData.Currency,
          LawyerID: HearderFormData.Lawyer,
          NoticeDt: HearderFormData.DateofNotice,
          ReceiptDt: HearderFormData.DateofReceiving,
          TargetDt: HearderFormData.TargetDate,
          DueDt: HearderFormData.DueDate,
          CategoryID: HearderFormData.Category,
          SubCategoryID: HearderFormData.SubCategory,
          ExposureAmt: HearderFormData.ExposureAmmount,
          NegotiationAmt: HearderFormData.NegotiationAmount,
          ReceivedAmt: HearderFormData.RecoveryAmount,
          BalanceAmt: HearderFormData.BalanceAmount,
          CompanyID: HearderFormData.Company,
          DeptID: HearderFormData.Department,
          StateID: HearderFormData.State,
          CityID: HearderFormData.City,
          CourtID: HearderFormData.Jurisdiction,
          CourtNo: HearderFormData.CourtName,
          LastDateToRespond: HearderFormData.LastDate,
          AgencyID: HearderFormData.Agency,
          ManagerID: HearderFormData.Manager,
          LeaderID: HearderFormData.Leader,
          Stages: HearderFormData.Stages,
          Seriousness: HearderFormData.Seriousness,
          recEnable: this.numb,
          recUser: this.numb,
          recAddUser: this.numb,
          Section: HearderFormData.Section.toString(),
          FIRDate: HearderFormData.FIRDate,
          FIRNo: HearderFormData.FIRNo,
          PoliceStation: HearderFormData.PoliceStation,
          InvestigatingOfficer: HearderFormData.InvestigatingOfficer,
          ManagerPreID: this.ManagerPreID,
          LeaderPreID: this.LeaderPreID,
          BenchNo: HearderFormData.BenchNo,
          JudgeName: HearderFormData.JudgeName,
          LawyerName: HearderFormData.LawyerName,
          PreBenchNo: this.PreBenchNo,
          PreJudgeName: this.PreJudgeName,
          PreLawyerID: this.PreLawyerID
         };
         this.http.get(this.url + 'Notice/AddTransferLog?ID='+this.id)
         .subscribe( (data1) =>   {

          this.http.get(this.url + 'Notice/FetchExistingNotice?ID=' + this.id)
          .subscribe( (data) =>   {
          const fetchHeaderdata: FetchTransferCase = JSON.parse(data.toString())[0];


          this.http.post(this.url + 'Notice/insertNoticeCase', noticeobj) .subscribe( (data) => {
            this.clicked = false;
            if (data == null) { this.alertService.error(' Some Error In Entered Record ',true);
           } else {
            this.http.post(this.url + 'Notice/InsertTransferCase', fetchHeaderdata) .subscribe( (data) => {
            if (this.id == 0) { this.alertService.success(' Successfully Added ',this.options);
                    } else { this.alertService.success(' Successfully Transfered ',this.options); }
                    data = data.toString().split(':');
                    this.getdata = data[1].toString().split('}');
                    this.id = this.getdata[0].toString();
                    this.HeaderButtonCaption = "Update";
                    this.DisplayExistNotice = "";
                    this.DisplaySaveNoticeButton = "submit";
                  });
                    }
              }
            );
         });
        });
          }
    }


 fetchNoticeCaseData() {
  this.http.get(this.url + 'Notice/FetchExistingNotice?ID=' + this.id)
  .subscribe( (data) =>   {
      if (data == null) {
        this.NoticeCaseData = null;
      } else {
        const fetchHeaderdata: FetchTransferCase = JSON.parse(data.toString())[0];
        if (fetchHeaderdata.StateID != null) {
          this.getMaster('015', fetchHeaderdata.StateID.toString()).subscribe( (data: any) => {
            this.City = data ; let data1: any; this.Jurisdiction = data1; }); }
        if (fetchHeaderdata.CityID != null) {
          this.getMaster('020', fetchHeaderdata.CityID.toString()).subscribe( (data: any) => { this.Jurisdiction = data; }); }
        if (fetchHeaderdata.CategoryID != null) {
          this.getMaster('050', fetchHeaderdata.CategoryID.toString()) .subscribe( (data: any) => { this.SubCategory = data; }); }
        this.getMaster('070', '') .subscribe( ( data: any) => {
            this.SectionList = data;
            if (fetchHeaderdata.Section != null  ) {
            this.selectedSections = fetchHeaderdata.Section.toString().split('~').map(Number); }
           });

        this.PreBenchNo=fetchHeaderdata.BenchNo;
        this.PreJudgeName=fetchHeaderdata.JudgeName;
        this.PreLawyerID=fetchHeaderdata.LawyerID;
        this.ManagerPreID = fetchHeaderdata.ManagerID == null ? 0 : fetchHeaderdata.ManagerID;
        this.LeaderPreID = fetchHeaderdata.LeaderID == null ? 0 : fetchHeaderdata.LeaderID;
        this.FetchShortName=fetchHeaderdata.ShortName;
        this.FetchReceivingDate=fetchHeaderdata.ReceiptDt == null ? "" : fetchHeaderdata.ReceiptDt;
        this.FetchCaseDate=fetchHeaderdata.NoticeDt; this.FetchExposureAmount=fetchHeaderdata.ExposureAmt;
        this.FetchCaseType=fetchHeaderdata.IsSent == false ? "Against Us":"Filled By Us";
        this.FetchRefNo=fetchHeaderdata.refno; this.FetchBalanceAmount=fetchHeaderdata.BalanceAmt;
        this.FetchTargetDate=fetchHeaderdata.TargetDt == null ? "" : fetchHeaderdata.TargetDt;
        this.FetchDueDate=fetchHeaderdata.DueDt == null ? "" : fetchHeaderdata.DueDt;
        this.FetchNegotiationAmount=fetchHeaderdata.NegotiationAmt;
        this.FetchLastDateRespond=fetchHeaderdata.LastDateToRespond == null ? "" : fetchHeaderdata.LastDateToRespond;
        this.FetchCourtNameNo=fetchHeaderdata.CourtNo; this.FetchRecoveryAmount=fetchHeaderdata.ReceivedAmt;
        this.FetchFirNo= fetchHeaderdata.FIRNo; this.FetchFIRDate= fetchHeaderdata.FIRDate == null ? "" : fetchHeaderdata.FIRDate;
        this.FetchPoliceStation= fetchHeaderdata.PoliceStation; this.FetchInvestigationOfficer= fetchHeaderdata.InvestigatingOfficer;
        this.FetchBenchNo= fetchHeaderdata.BenchNo; this.FetchJudgeName= fetchHeaderdata.JudgeName;
        this.FetchState=fetchHeaderdata.stateName; this.FetchCity=fetchHeaderdata.cityName; this.FetchJurisdiction=fetchHeaderdata.jurisdictionName;
        this.FetchAgency=fetchHeaderdata.agencyName; this.FetchManager=fetchHeaderdata.managerName;
        this.FetchLeader=fetchHeaderdata.LeaderName; this.FetchCurrency=fetchHeaderdata.currencyName;
        this.FetchCategory=fetchHeaderdata.categoryName; this.FetchSubCategory=fetchHeaderdata.subcategoryName;
        this.FetchDepartment=fetchHeaderdata.departmentName; this.FetchCompany=fetchHeaderdata.companyName;
        this.FetchLawyerName=fetchHeaderdata.LawyerName; this.FetchStatus=fetchHeaderdata.statusName;
        this.FetchSection=fetchHeaderdata.SectionName; this.FetchSeriousness=fetchHeaderdata.seriousnessName;
    this.addFormTranferCase.patchValue({
          Agency: fetchHeaderdata.AgencyID == null ? 0 : fetchHeaderdata.AgencyID, ShortName : fetchHeaderdata.ShortName,
          Manager: fetchHeaderdata.ManagerID == null ? 0 : fetchHeaderdata.ManagerID,
          Currency: fetchHeaderdata.CurrencyID == null ? 0 : fetchHeaderdata.CurrencyID,
          Lawyer: fetchHeaderdata.LawyerID == null ? 0 : fetchHeaderdata.LawyerID,
          DateofReceiving: fetchHeaderdata.ReceiptDt == null ? "" : fetchHeaderdata.ReceiptDt,
          Category: fetchHeaderdata.CategoryID == null ? 0 : fetchHeaderdata.CategoryID, DateofNotice: fetchHeaderdata.NoticeDt,
          SubCategory: fetchHeaderdata.SubCategoryID == null ? 0 : fetchHeaderdata.SubCategoryID,
          ExposureAmmount: fetchHeaderdata.ExposureAmt, Notice: fetchHeaderdata.IsSent == false ? "0" : "1",
          Company: fetchHeaderdata.CompanyID == null ? 0 : fetchHeaderdata.CompanyID,
          Department: fetchHeaderdata.DeptID == null ? 0 : fetchHeaderdata.DeptID, RefNo: fetchHeaderdata.refno,
          State: fetchHeaderdata.StateID == null ? 0 : fetchHeaderdata.StateID, BalanceAmount: fetchHeaderdata.BalanceAmt,
          TargetDate: fetchHeaderdata.TargetDt == null ? "" : fetchHeaderdata.TargetDt,
          Leader: fetchHeaderdata.LeaderID == null ? 0 : fetchHeaderdata.LeaderID,
          DueDate: fetchHeaderdata.DueDt == null ? "" : fetchHeaderdata.DueDt, NegotiationAmount: fetchHeaderdata.NegotiationAmt,
           City: fetchHeaderdata.CityID == null ? 0 : fetchHeaderdata.CityID,
          LastDate: fetchHeaderdata.LastDateToRespond == null ? "" : fetchHeaderdata.LastDateToRespond,
          Stages: fetchHeaderdata.Stages == null ? 0 : fetchHeaderdata.Stages, CourtName: fetchHeaderdata.CourtNo,
          Jurisdiction: fetchHeaderdata.CourtID == null ? 0 : fetchHeaderdata.CourtID, RecoveryAmount: fetchHeaderdata.ReceivedAmt,
          Seriousness: fetchHeaderdata.Seriousness == null ? 0 : fetchHeaderdata.Seriousness,
          FIRNo: fetchHeaderdata.FIRNo, FIRDate: fetchHeaderdata.FIRDate == null ? "" : fetchHeaderdata.FIRDate,
          PoliceStation: fetchHeaderdata.PoliceStation, InvestigatingOfficer: fetchHeaderdata.InvestigatingOfficer,
          BenchNo: fetchHeaderdata.BenchNo, JudgeName: fetchHeaderdata.JudgeName, LawyerName: fetchHeaderdata.LawyerName
        });
      }
     }
  );
}
  goBack(){
    window.history.back();
  }
}
